import { injectable } from "inversify";
import { Data } from '@singularsystems/neo-core';

@injectable()
export default class AuthorisationDataCache extends Data.CachedDataService {

}